import type { Bonus } from '../types/kit';

export const CHECKOUT_URL = 'https://kids-activity-club.impultienda.ar/checkout';

export const META_PIXEL_ID = '2335234447313587';

export const mockupImage = 'https://cdn.magicpatterns.com/uploads/ukA8VPmybiR3QBmjfa5j14/kid_1.png';
export const mockupAlt =
  'Kids Activity Club Volume 1 shown on a desktop screen, with the five bonus guides shown on tablets';

export const volumeCoverImage = 'https://cdn.magicpatterns.com/uploads/rRG8wXNyk6WvBtHtrznaDV/01_portada.png';

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Rainy-Day Rescue Kit',
    description:
      '12 indoor activities with a complete 20-minute plan, everyday materials and seated options. Keep a backup ready when outdoor plans change.',
    image: 'https://cdn.magicpatterns.com/uploads/wTQwhwCBE5b8yCrpoGWyiS/kid_1.webp',
  },
  {
    number: '02',
    title: '30 Five-Minute Fillers',
    description:
      'Arrival games, transitions and early-finisher activities. Fill a short gap without designing another game on the spot.',
    image: 'https://cdn.magicpatterns.com/uploads/fBNDQttCYjnbJFSYxhJbov/kid_2.webp',
  },
  {
    number: '03',
    title: 'The Group Leader Script Kit',
    description:
      'Ready-to-read words and routines for 20 everyday situations, from explaining a game to sharing supplies and closing the session.',
    image: 'https://cdn.magicpatterns.com/uploads/raNMdaWVbYs8BoUSWkMZ4v/kid_3.webp',
  },
  {
    number: '04',
    title: '24 Print-and-Play Team Mission Cards',
    description:
      'Extra cooperative challenges across observation, memory, logic, building, storytelling and teamwork, with facilitator notes and adaptations.',
    image: 'https://cdn.magicpatterns.com/uploads/iY5zr6ozSUfZZjojFJ9E1G/kid_4.webp',
  },
  {
    number: '05',
    title: 'Parent Communication & Club Admin Pack',
    description:
      '20 ready-to-edit messages plus attendance, supplies and session-note templates. Organize the work around the weekly encounter.',
    image: 'https://cdn.magicpatterns.com/uploads/huzMWLLrwYFzvZeS2NnunX/kid_5.webp',
  },
];

export const weeks = [
  'Welcome to the Club',
  'Shape Explorers',
  'Memory Museum',
  'Team Delivery',
  'Pattern Playground',
  'Story Builders',
  'Cup City',
  'Detective Trail',
  'Rhythm & Mirrors',
  'Paper Bridge Lab',
  'Treasure Map Teams',
  'Kindness Quest',
  'Mission Mix',
];

export const heroPoints = ['1 volume', '5 bonuses', '13 sessions', '45-minute plans', 'Ages 5–8'];

export const stats = [
  { value: '13', label: 'Weekly sessions' },
  { value: '1 + 5', label: 'Volume & bonuses' },
  { value: '45 MIN', label: 'Approximate session length' },
  { value: '5–8', label: "Children's ages" },
];

export const fitTags = [
  'Movement & coordination',
  'Observation & memory',
  'Logic & construction',
  'Cooperation',
  'Expression & imagination',
];

export const offerIncludes = [
  'Volume 1: Play, Connect & Cooperate',
  '13 complete weekly sessions',
  'Materials, scripts & timed steps',
  'Resources & adaptations',
  'The Rainy-Day Rescue Kit',
  '30 Five-Minute Fillers',
  'The Group Leader Script Kit',
  '24 Print-and-Play Team Mission Cards',
  'Parent Communication & Club Admin Pack',
];
